module.exports = __webpack_public_path__ + "assets/Pharma.b22dccb5.svg";